export function subscribe(id) {
    return {
        type: 'EVENTS_SUBSCRIBE',
        id
    };
}
